import ResourceService from "./resource.service";

class TaxTypeService extends ResourceService {
  static get resource() {
    return "tax-type";
  }
}

export default TaxTypeService;
